import script from "./HeaderGreenApiToggler.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderGreenApiToggler.vue?vue&type=script&setup=true&lang=js"

import "./HeaderGreenApiToggler.vue?vue&type=style&index=0&id=40a175bd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40a175bd"]])

export default __exports__